var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{style:(_vm.pageStyles)},[_c('container',{ref:"container"},[(_vm.decorationJson)?_c('Widget',{attrs:{"json":_vm.decorationJson},on:{"decorationData":_vm.onDecorationData}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }